export default __webpack_public_path__ + "static/media/icon-empty-activejobs.5b32e6c8.svg";